export const returnToMainScreen = (url: string) => {
  switch (true) {
    case url.startsWith("/content"):
      return "content/explorer";
    case url.startsWith("/campaigns"):
      return "campaigns";
    case url.startsWith("/audiences"):
      return "audiences";
    case url.startsWith("/analytics"):
      return "analytics";
    case url.startsWith("/automation"):
      return "/automation";
    case url.startsWith("/groups"):
      return "/groups";
    default:
      return "campaigns";
  }
};
